"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../_util/utils");
var _jsxRuntime = require("react/jsx-runtime");
const ButtonGroup = props => {
  var _React$Children$map;
  const {
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    size = 'm',
    children,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-buttonGroup");
  const _children = (_React$Children$map = _react.default.Children.map(children, child => child)) === null || _React$Children$map === void 0 ? void 0 : _React$Children$map.filter(c => /*#__PURE__*/_react.default.isValidElement(c));
  const childBtnCount = _react.default.Children.count(_children);
  const attrs = (0, _utils.pickDomAttrs)(restProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...attrs.data,
    className: baseClassName,
    children: _children === null || _children === void 0 ? void 0 : _children.map((child, index) => {
      var _child$props;
      return /*#__PURE__*/_react.default.cloneElement(child, {
        prefixClass,
        size: ((_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.size) || size,
        className: (0, _classnames.default)("".concat(baseClassName, "-buttonChild"), {
          ["".concat(baseClassName, "-buttonChild-first")]: index === 0,
          ["".concat(baseClassName, "-buttonChild-last")]: index === childBtnCount - 1
        })
      });
    })
  });
};
var _default = exports.default = ButtonGroup;